$(document).on('click', '.landing-edit-mode .b-flip-card', function(e) {
   $(this).toggleClass('is-flipped');
});